import * as number from './Number';

export const Number = number;
